import React from 'react';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Tabs, Tab } from 'react-bootstrap';
import ServicesTab from './services/ServicesTab';
import LogsTab from './logs/LogsTab';
import EndpointsInfoTab from './endpointsInfo/EndpointsInfoTab';
import QueuesTab from './queues/QueuesTab';

class Console extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = (props) => {
        return {
            activeTab: "services"
        };
    }

    onTabSelect = (key) => {
        this.setState({
            activeTab: key
        })
    }

    render() {

        const tabs = [
            { key: "services", title: "Services", comp: ServicesTab },
            { key: "logs", title: "Logs", comp: LogsTab },
            { key: "endpoints", title: "Endpoints", comp: EndpointsInfoTab },
            { key: "queues", title: "Queues", comp: QueuesTab }
        ];

        let supportTabs = tabs.map(tab => {
            const Comp = tab.comp;

            return (
                <Tab key={tab.key} eventKey={tab.key} title={tab.title}>
                    <div className='tab-pane'>
                        <div className='panel-body'>
                            {this.state.activeTab === tab.key &&
                                <Comp helpKey={tab.helpKey} />}
                        </div>
                    </div>
                </Tab>
            );
        });

        return (
            <div>
                <ContentHeader title="Tech Support" description="Monitoring console" />
                <ContentBody>
                    <Tabs id="dashboardTabs" className="tabs-container" onSelect={this.onTabSelect}>
                        {supportTabs}
                    </Tabs>
                </ContentBody>
            </div>
        );
    }
}

export default Console;



// WEBPACK FOOTER //
// ./src/areas/admin/console/Console.js